import { render, staticRenderFns } from "./json-view.vue?vue&type=template&id=6385680d&scoped=true"
import script from "./json-view.vue?vue&type=script&lang=js"
export * from "./json-view.vue?vue&type=script&lang=js"
import style0 from "./json-view.vue?vue&type=style&index=0&id=6385680d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6385680d",
  null
  
)

export default component.exports